import React, { useEffect, useState } from 'react';
import {
  Table,
  Button,
  Input,
  Select,
  Popconfirm,
  Space,
  Card,
  Flex,
} from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { BiSolidShow } from 'react-icons/bi';
import { queryKeys } from '../../../services/react-query/queryKeys';
import {
  getSearchApiIsStock,
  getSearchPatients,
} from '../../../network/appointment';
import { useQuery } from '@tanstack/react-query';
const SalesTeamList = ({ setDataSource, dataSource, t, form }) => {
  const [searchTextItems, setSearchTextItems] = useState('');
  const [count, setCount] = useState(0);
  const { data: itemsList } = useQuery({
    queryKey: [queryKeys.getSearchApiSales, searchTextItems],
    queryFn: () => getSearchPatients('Sales Person', searchTextItems),
    keepPreviousData: true,
    enabled: searchTextItems?.length >= 3 || searchTextItems?.length === 0,
  });
  // console.log(type, 'typetype swww');
  const columns = [
    {
      title: t.salesPerson,
      dataIndex: 'sales_person',
      render: (text, record, index) => (
        <Select
          placeholder={t.salesPerson}
          value={record?.sales_person}
          style={{ width: '100%' }}
          showSearch
          allowClear
          filterOption={false}
          onSearch={(value) => {
            setSearchTextItems(value);
          }}
          popupMatchSelectWidth={false}
          onChange={(value) => {
            const newDataSource = [...dataSource];
            newDataSource[index].sales_person = value;
            setDataSource(newDataSource);
          }}
        >
          {itemsList?.message?.map((item) => (
            <Select.Option key={item?.value} value={item?.value}>
              <Flex gap={1} vertical>
                <span>{item?.value}</span>
                <span
                  className="item-description"
                  style={{ fontSize: '11px', color: 'gray' }}
                >
                  {item?.description}
                </span>
              </Flex>
            </Select.Option>
          ))}
        </Select>
      ),
    },
    {
      title: t.allocatedPercentage,
      dataIndex: 'allocated_percentage',
      render: (text, record, index) => (
        <Input
          placeholder={t.allocatedPercentage}
          type="number"
          value={record.allocated_percentage}
          min={0}
          width={100}
          style={{ width: '100%' }}
          onChange={(e) => {
            const newDataSource = [...dataSource];
            newDataSource[index].allocated_percentage = e.target.value;
            setDataSource(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.allocatedAmount,
      dataIndex: 'allocated_amount',
      render: (text, record, index) => (
        <Input
          placeholder={t.allocatedAmount}
          type="number"
          value={record.allocated_amount}
          min={0}
          style={{ width: '100%' }}
          onChange={(e) => {
            const newDataSource = [...dataSource];
            newDataSource[index].allocated_amount = e.target.value;
            setDataSource(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.incentives,
      dataIndex: 'incentives',
      render: (text, record, index) => (
        <Input
          placeholder={t.incentives}
          type="number"
          value={record.incentives}
          min={0}
          style={{ width: '100%' }}
          onChange={(e) => {
            const newDataSource = [...dataSource];
            newDataSource[index].incentives = e.target.value;
            setDataSource(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.action,
      key: 'action',
      render: (text, record, index) => (
        <Space>
          <Popconfirm
            title={t.confirmDelete}
            onConfirm={() => handleDelete(record.key)}
          >
            <Button
              type="primary"
              danger
              icon={<DeleteOutlined />}
              size="small"
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const handleAdd = () => {
    const newData = {
      key: count,
    };
    setDataSource([...dataSource, newData]);
    setCount(count + 1);
  };

  const handleDelete = (key) => {
    const newDataSource = dataSource.filter((item) => item.key !== key);
    setDataSource(newDataSource);
  };

  return (
    <Card>
      <Table
        className="table_custom"
        dataSource={dataSource}
        columns={columns}
        pagination={{
          hideOnSinglePage: true,
        }}
        scroll={{ x: 'max-content' }}
        // className="table"
        rowKey="key"
      />
      <Button
        onClick={handleAdd}
        type="primary"
        ghost
        style={{ marginTop: '20px', borderRadius: '6px' }}
        icon={<PlusOutlined />}
        size="small"
      >
        {t.addRow}
      </Button>
    </Card>
  );
};

export default SalesTeamList;
